<template>
    <div>
        <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
        <div class="row">
          <div class="col-md-12">
              <div class="top-list-small-toolbar">
                <h4 class="text-primary">Payment Giro</h4>
                <form class="form-inline">
                  <div class="form-group col-xs-12 col-sm-6 col-md-4 col-lg-2">
                    <label><b>Salesman:</b></label>
                    <v-select :options="getUserSalesman" :reduce="salesman => salesman.meta.code" label="salesman" v-model="salesman_id" class="vsc-custom vsc-custom-inline"/>
                  </div>
                  <div class="form-group col-xs-12 col-sm-6 col-md-4 col-lg-2">
                    <label><b>Company:</b></label>
                    <select v-model="company_no" class="form-control form-ctrl-inline">
                      <option value="">-- All --</option>
                      <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                    </select>
                  </div>
                  <div class="form-group col-xs-12 col-sm-6 col-md-4 col-lg-2">
                    <label><b>Term:</b></label>
                    <select v-model="term" class="form-control form-ctrl-inline">
                      <option value="all">-- All --</option>
                      <option value="outstanding">Giro Belum Cair</option>
                    </select>
                  </div>
                  <div class="form-group col-xs-12 col-sm-6 col-md-4 col-lg-2">
                    <label><b>Type:</b></label>
                    <select v-model="type" class="form-control form-ctrl-inline">
                      <option value="create">Giro Dibuat (create date)</option>
                      <option value="finish">Giro Cair (finish date)</option>
                    </select>
                  </div>

                  <div class="form-group col-xs-12 col-sm-6 col-md-4 col-lg-2">
                    <label><b>Date:</b></label>
                    <date-picker v-model="startDate" type="date" range placeholder="Select date range"></date-picker>
                  </div>
                  <div class="form-group col-xs-12 col-sm-6 col-md-4 col-lg-2">
                    <button type="button" class="btn btn-sm btn-hard-primary waves-light waves-effect" @click="refreshList">
                      <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                    </button>
                    <button class="btn btn-warning btn-sm pull-left dropdown-toggle" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="print">
                      <a class="dropdown-item" href="javascript:void(0)" @click="processReport">Process</a>
                      <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf')">Print PDF</a>
                      <a class="dropdown-item" href="javascript:void(0)" @click="print('excel')">Export to Excel</a>
                    </div>
                  </div>
                </form>
              </div>
          </div>
        </div>
        <div class="row" style="margin-top: 120px">
          <div class="col-md-6">
            <div class="alert alert-info" role="alert">
              <ul>
                <li v-if="type === 'create'"><strong>Range date</strong> adalah tanggal <strong>Giro Dibuat</strong></li>
                <li v-else><strong>Range date</strong> adalah tanggal <strong>Giro Cair</strong></li>
                <li>Giro dihitung mulai dari <strong>Tanggal cair (finish date)</strong></li>
                <li><strong>Giro</strong> belum cair dihitung dari tanggal terakhir <strong>Range date</strong></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-info">Total Subtotal</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalSubtotal | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-info">Total Discount</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalDiscount | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-info">Total Rounding</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalRounding | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-success">Total Giro</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalGiro | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-success">Total Sales Payment</span></h5>
                <h3 class="my-3">
                  {{ totalSalesPayment | currency }}
                </h3>
              </div>
              <!--end card-body-->
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-warning">Total Giro Belum Cair</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalGiroBelumCair | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-danger">Total Giro Void</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalGiroVoid | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-12">
                          <ul class="nav nav-tabs nav-bordered">
                            <li class="nav-item"><a href="#payment-giro" data-toggle="tab" aria-expanded="false" class="nav-link active">Data Payment</a></li>
                            <li class="nav-item"><a href="#payment-belum-cair" data-toggle="tab" aria-expanded="false" class="nav-link">Giro belum Cair</a></li>
                          </ul>
                          <div class="tab-content">
                            <div class="tab-pane active" id="payment-giro">
                              <div v-for="i in filterData" :key="i.id">
                                  <div v-for="a in i.areas" :key="a.name">
                                      <h5 style="margin-top: 50px" class="text-center"><b>{{ i.salesman_id }}</b> - {{ i.salesman }}</h5>
                                      <h5 class="text-center">{{ a.name }}</h5>
                                      <div class="table-responsive">
                                          <table class="table table-item mb-0 table-sm table-striped table-hover">
                                              <thead>
                                                  <th>#</th>
                                                  <th>Ref No.</th>
                                                  <th>Salesman</th>
                                                  <th>Type</th>
                                                  <th>Method</th>
                                                  <th>Status</th>
                                                  <th>Customer</th>
                                                  <th>Date</th>
                                                  <th>Finish Date</th>
                                                  <th>Age</th>
                                                  <th class="text-right">Retur</th>
                                                  <th class="text-right">Uang Muka</th>
                                                  <th class="text-right">Subtotal</th>
                                                  <th class="text-right">Discount</th>
                                                  <th class="text-right">Tax</th>
                                                  <th class="text-right">Round</th>
                                                  <th class="text-right">Payment</th>
                                                  <th class="text-right">Total</th>
                                                  <th class="text-right">Outstanding</th>
                                              </thead>
                                              <tbody>
                                                  <tr v-for="s in a.saleColl" :key="s.id">
                                                      <td>
                                                          <label v-if="s.type === 'payment'" class="form-checkbox">
                                                          <!-- <input type="checkbox" :value="s.id" v-model="selected" @change="uncheckReportPayment(s.id, s.ref_no)"><i class="form-icon"></i> -->
                                                          <input type="checkbox" :value="s.id" v-model="selected"><i class="form-icon"></i>
                                                          </label>
                                                      </td>
                                                      <td>
                                                          <span v-if="s.type === 'sales'" class="ml-5 text-ref-sales" @click="showSaleNo(s.ref_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">{{ s.ref_no}}</span>
                                                          <span v-else data-toggle="modal" @click="showPaymentNo(s.ref_no)" data-target="#modalPaymentGroup" data-backdrop="static" data-keyboard="false"><b>{{ s.ref_no }}</b></span>
                                                      </td>
                                                      <td>
                                                        <span>{{ s.salesman }}</span>
                                                      </td>
                                                      <td>
                                                          <span class="badge badge-success" v-if="s.type === 'payment'">{{ s.type }}</span>
                                                          <span class="badge badge-warning" v-else>{{ s.type }}</span>
                                                      </td>
                                                      <td>
                                                          <span class="badge badge-primary" v-if="s.method === 'Tunai'">{{ s.method }}</span>
                                                          <span class="badge badge-info" v-else-if="s.method === 'Giro'">{{ s.method }}</span>
                                                          <span class="badge badge-warning" v-else>{{ s.method }}</span>
                                                      </td>
                                                      <td>
                                                        <span class="badge badge-success" v-if="s.status === 'open'">{{ s.status }}</span>
                                                        <span class="badge badge-primary" v-else-if="s.status === 'approved'">{{ s.status }}</span>
                                                        <span class="badge badge-danger" v-else-if="s.status === 'void'">{{ s.status }}</span>
                                                      </td>
                                                      <td>{{ s.customer }}</td>
                                                      <td>{{ s.date | dateFormat('DD/MM/YYYY') }}</td>
                                                      <td>{{ s.finish_date | dateFormat('DD/MM/YYYY')}}</td>
                                                      <td>{{ s.age | currency }}</td>
                                                      <td class="text-right">{{ s.retur_total | currency }}</td>
                                                      <td class="text-right">{{ s.uangmuka | currency }}</td>
                                                      <td class="text-right">{{ s.subtotal | currency }}</td>
                                                      <td class="text-right">{{ s.discount | currency }}</td>
                                                      <td class="text-right">{{ s.tax | currency }}</td>
                                                      <td class="text-right">{{ s.round | currency }}</td>
                                                      <td class="text-right">{{ s.payment_amount | currency }}</td>
                                                      <td class="text-right">{{ s.total | currency }}</td>
                                                      <td class="text-right">{{ s.outstanding | currency }}</td>
                                                  </tr>
                                              </tbody>
                                          </table>
                                      </div>
                                  </div>
                              </div>
                            </div>
                            <div class="tab-pane" id="payment-belum-cair">
                              <div class="table-responsive">
                                <table class="table table-item mb-0 table-sm table-striped table-hover">
                                  <thead>
                                    <th>Ref No.</th>
                                    <th>Type</th>
                                    <th>Method</th>
                                    <th>Status</th>
                                    <th>Customer</th>
                                    <th>Date</th>
                                    <th>Finish Date</th>
                                    <th>Age</th>
                                    <th class="text-right">Retur</th>
                                    <th class="text-right">Uang Muka</th>
                                    <th class="text-right">Subtotal</th>
                                    <th class="text-right">Discount</th>
                                    <th class="text-right">Tax</th>
                                    <th class="text-right">Round</th>
                                    <th class="text-right">Payment</th>
                                    <th class="text-right">Total</th>
                                    <th class="text-right">Outstanding</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="s in giroBelumCair" :key="s.id">
                                      <td>
                                        <span data-toggle="modal" @click="showPaymentNo(s.ref_no)" data-target="#modalPaymentGroup" data-backdrop="static" data-keyboard="false"><b>{{ s.ref_no }}</b></span>
                                      </td>
                                      <td>
                                        <span class="badge badge-success" v-if="s.type === 'payment'">{{ s.type }}</span>
                                        <span class="badge badge-warning" v-else>{{ s.type }}</span>
                                      </td>
                                      <td>
                                        <span class="badge badge-primary" v-if="s.method === 'Tunai'">{{ s.method }}</span>
                                        <span class="badge badge-info" v-else-if="s.method === 'Giro'">{{ s.method }}</span>
                                        <span class="badge badge-warning" v-else>{{ s.method }}</span>
                                      </td>
                                      <td>
                                        <span class="badge badge-success" v-if="s.status === 'open'">{{ s.status }}</span>
                                        <span class="badge badge-primary" v-else-if="s.status === 'approved'">{{ s.status }}</span>
                                        <span class="badge badge-danger" v-else-if="s.status === 'void'">{{ s.status }}</span>
                                      </td>
                                      <td>{{ s.customer }}</td>
                                      <td>{{ s.date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>{{ s.finish_date | dateFormat('DD/MM/YYYY')}}</td>
                                      <td>{{ s.age | currency }}</td>
                                      <td class="text-right">{{ s.retur_total | currency }}</td>
                                      <td class="text-right">{{ s.uangmuka | currency }}</td>
                                      <td class="text-right">{{ s.subtotal | currency }}</td>
                                      <td class="text-right">{{ s.discount | currency }}</td>
                                      <td class="text-right">{{ s.tax | currency }}</td>
                                      <td class="text-right">{{ s.round | currency }}</td>
                                      <td class="text-right">{{ s.payment_amount | currency }}</td>
                                      <td class="text-right">{{ s.total | currency }}</td>
                                      <td class="text-right">{{ s.outstanding | currency }}</td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td class="text-right"><b>{{ totalGroupGiroBelumCair | currency }}</b></td>
                                      <td></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <!-- <div class="row">
                                <div class="col-md-6"><pre>{{ giroBelumCair }}</pre></div>
                                <div class="col-md-6"><pre>{{ dataRaw }}</pre></div>
                              </div> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <SaleModal />
        <PaymentGroupModal />
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { reportTransactionUrl, reportUrl, getHeader, report2Url, paymentUrl, customerUrl } from '@/config'
import SaleModal from '@/components/sales/SaleModal.vue'
import PaymentGroupModal from '@/components/payment/PaymentGroupModal.vue'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'PaymentGroupReportGiro',
  props: ['scroll'],
  components: {
    Loading,
    SaleModal,
    PaymentGroupModal,
    DatePicker
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth(), date.getDate())
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      dateNow: new Date(),
      loadingSales: true,
      selected: [],
      startDate: [date1, date2],
      term: 'all',
      type: 'create',
      salesman_id: '',
      company_no: '',
      year: '2022',
      date: null,
      typeData: null,
      period: [],
      dataRaw: [],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      searchQuery: '',
      ascending: true,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1
    }
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getEmployeeList')
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList,
      employeeList: state => state.employees.employeeList,
      authUser: state => state.users.authUser
    }),
    giroBelumCair () {
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      const dateGiro = new Date(end).getTime()
      const array = this.dataRaw
      var loop = []
      for (let i = 0; i < array.length; i++) {
        const area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          const sale = area[z].saleColl
          for (let a = 0; a < sale.length; a++) {
            if (sale[a].level === 1) {
              const finish = new Date(sale[a].finish_date)
              const newFinish = finish.getFullYear() + '-' + (finish.getMonth() + 1) + '-' + finish.getDate()
              const finishTime = new Date(newFinish).getTime()
              if (finishTime > dateGiro) {
                loop.push(sale[a])
              }
            }
          }
        }
      }
      return loop
    },
    totalGroupGiroBelumCair () {
      var array = this.giroBelumCair
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalSalesPayment () {
      let sum = 0
      const array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        const area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          const sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].level === 2) {
              sum += parseFloat(sale[c].payment_amount)
            }
          }
        }
      }
      return sum
    },
    totalSubtotal () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].method === 'Giro') {
              if (sale[c].status !== 'void') {
                sum += parseFloat(sale[c].subtotal)
              }
            }
          }
        }
      }
      return sum
    },
    totalDiscount () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].method === 'Giro') {
              if (sale[c].status !== 'void') {
                sum += parseFloat(sale[c].discount)
              }
            }
          }
        }
      }
      return sum
    },
    totalRounding () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let a = 0; a < area.length; a++) {
          var sale = area[a].saleColl
          for (let z = 0; z < sale.length; z++) {
            sum += parseFloat(sale[z].round)
          }
        }
      }
      return sum
    },
    totalGiroBelumCair () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let a = 0; a < area.length; a++) {
          sum += parseFloat(area[a].total_giro_belum_cair)
        }
      }
      return sum
    },
    groupGiro () {
      var array = this.dataRaw
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var array2 = array[i].areas
        for (let a = 0; a < array2.length; a++) {
          var array3 = array2[a].saleColl
          for (let z = 0; z < array3.length; z++) {
          }
        }
      }
      return loop
    },
    groupData () {
      var result = []
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let j = 0; j < area.length; j++) {
          var saleColl = area[j].saleColl
          for (let k = 0; k < saleColl.length; k++) {
            result.push(saleColl[k])
          }
        }
      }
      return result
    },
    totalUangMuka () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].method === 'Uang Muka') {
              sum += parseFloat(sale[c].total)
            }
          }
        }
      }
      return sum
    },
    totalGiro () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].method === 'Giro') {
              if (sale[c].status !== 'void') {
                sum += parseFloat(sale[c].total)
              }
            }
          }
        }
      }
      return sum
    },
    totalGiroVoid () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].method === 'Giro') {
              if (sale[c].status === 'void') {
                sum += parseFloat(sale[c].total)
              }
            }
          }
        }
      }
      return sum
    },
    totalTunai () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].method === 'Tunai') {
              sum += parseFloat(sale[c].total)
            }
          }
        }
      }
      return sum
    },
    totalTransfer () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].method === 'Transfer Bank') {
              sum += parseFloat(sale[c].total)
            }
          }
        }
      }
      return sum
    },
    getUserSalesman: function () {
      var array = this.employeeList.filter(e => e.position_id === 'H4.1' || e.position_id === 'H4.2' || e.position_id === 'H1' || e.position_id === 'H2')
      var loop = [{
        salesman: '-- All --',
        meta: {
          code: ''
        }
      }]
      for (let a = 0; a < array.length; a++) {
        var obj = {
          salesman: '[' + array[a].employee_no + '] ' + array[a].name,
          meta: {
            code: array[a].employee_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    async showPaymentNo (refNo) {
      const payload = {
        group_no: refNo
      }
      this.$store.dispatch('getPaymentByNo', payload)
    },
    async uncheckReportPayment (id, refNo) {
      var array = this.selected
      var status = false
      for (let i = 0; i < array.length; i++) {
        if (array[i] === id) {
          status = true
        } else {
          status = false
        }
      }
      if (status === false) {
        var obj = {
          payment_no: refNo
        }
        await axios.post(reportTransactionUrl + '/remove-report-payment', obj, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
    },
    showSaleNo (no) {
      var payload = {
        sale_no: no
      }
      this.$store.commit('SET_SALE_BY_NO', payload)
      this.$store.dispatch('getSaleByNo', payload)
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      //   this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      this.selected = []
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        company_no: this.company_no,
        salesman: this.salesman_id,
        term: this.term,
        method_id: 3,
        type: this.type
      }
      console.log(obj)
      console.log(reportUrl + '/payment-by-sales-area')
      await axios.post(reportUrl + '/payment-by-sales-area', obj, { headers: getHeader() })
        .then(response => {
          this.dataRaw = response.data.data
          for (let i = 0; i < this.dataRaw.length; i++) {
            var area = this.dataRaw[i].areas
            for (let a = 0; a < area.length; a++) {
              var sale = area[a].saleColl
              for (let b = 0; b < sale.length; b++) {
                if (sale[b].report_count > 0) {
                  this.selected.push(sale[b].id)
                }
              }
            }
          }
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async processReport () {
      this.$Progress.start()
      this.loader.isLoading = true
      // var dateReport = new Date()
      // dateReport = dateReport.getFullYear() + '-' + (dateReport.getMonth() + 1) + '-' + dateReport.getDate()
      for (let c = 0; c < this.selected.length; c++) {
        for (let b = 0; b < this.groupData.length; b++) {
          if (this.groupData[b].id === this.selected[c]) {
            var obj = {
              payment_no: this.groupData[b].ref_no,
              company_no: this.groupData[b].company_no,
              report_date: this.groupData[b].date,
              username: this.authUser.username,
              notes: null
            }
            await axios.post(reportTransactionUrl + '/create-payment-sales', obj, { headers: getHeader() })
              .then(response => {
                console.log(response.data.message)
              })
              .catch(error => {
                this.$Progress.finish()
                this.loader.isLoading = false
                console.log(error)
                console.log(error.response)
                this.$swal('Error 101', '<pre>' + error + '</pre>', 'error')
                this.$swal('Error 102', error.response.data.message, 'error')
                throw error
              })
            const body = {
              id: this.groupData[b].id
            }
            await axios.post(paymentUrl + '/journal-sales', body, { headers: getHeader() })
              .then(response => {
                console.log(response.data.message)
              })
              .catch(error => {
                this.$Progress.finish()
                this.loader.isLoading = false
                console.log(error)
                console.log(error.response)
                this.$swal('Error 101', '<pre>' + error + '</pre>', 'error')
                this.$swal('Error 102', error.response.data.message, 'error')
                throw error
              })
            // Update Customer rating
            await axios.post(customerUrl + '/sales-outstanding-expire', { customer_no: this.groupData[b].customer_no }, { headers: getHeader() })
              .then(response => {
                console.log(response.data.message)
              })
              .catch(error => {
                this.$Progress.finish()
                this.loader.isLoading = false
                console.log(error)
                console.log(error.response)
                this.$swal('Error 101', '<pre>' + error + '</pre>', 'error')
                this.$swal('Error 102', error.response.data.message, 'error')
                throw error
              })
          }
        }
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async print (type) {
      this.$Progress.start()
      this.loader.isLoading = true
      var data = {
        format: type,
        data: this.dataRaw
      }
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      await axios.post(report2Url + '/payment-giro', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    }
  }
}
</script>

<style scoped>
.header-period {
    background-color: #6FB56F;
    color: white;
}
.text-ref-sales {
    color: #28A745;
    cursor: pointer;
}
</style>
